<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header" style="background-color: #be0c4d;">
      <h5 style="color: white;">Datos Básicos</h5>
    </div>
    <div class="card-body">
      <form>
        <div>
          <label><b>Información de la entidad</b></label>
        </div>
        <div class="row">
          <div class="col-2">
            <label>NIT :</label>
          </div>
          <div class="col-2">
            <input type="text" class="form-control" name="nit" [(ngModel)]="fuenteUsu.nit">
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label>Razón social :</label>
          </div>
          <div class="col-10">
            <input type="text" class="form-control" name="razon" [(ngModel)]="fuenteUsu.nombEntidad">
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label>Departamento :</label>
          </div>
          <div class="col-4">
            <select class="form-select" aria-label="Default select example" name="depto" (change)="getMunicByDepto($event.target.value)">
                <option  value="{{muniFte.coddepto}}" selected="selected">{{muniFte.departamento}}</option>
                <option *ngFor="let depto of Departamentos" value="{{depto.codigo}}">{{depto.nombre}}</option>
              </select>
          </div>
          <div class="col-2" style="text-align: end;">
            <label>Municipio :</label>
          </div>
          <div class="col-4">
            <select class="form-select" aria-label="Default select example" name="muni" (change)="setMunici($event.target.value)">
              <option  value="{{muniFte.codmpio}}" selected="selected">{{muniFte.nommpio}}</option>
              <option *ngFor="let muni of Municipios" value="{{muni.codmpio}}">{{muni.nommpio}}</option>
              </select>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label>Dirección :</label>
          </div>
          <div class="col-10">
            <div class="input-group">
              <input type="text" class="form-control" name="direccionfuente" [(ngModel)]="fuenteUsu.direccion" aria-label="Recipient's username" aria-describedby="button-addon2" disabled>
              <button class="btn btn-outline-secondary" type="button" data-bs-toggle="modal" data-bs-target="#modalPoll-NormDir" (click)="NormalizandoDirecccion()"><i class="fa fa-location-arrow" aria-hidden="true"></i></button>
            </div>
          </div>
        </div>
        <div>
          <label><b>Información del usuario responsable</b></label>
        </div>
        <div class="row">
          <div class="col-2">
            <label>Nombre :</label>
          </div>
          <div class="col-10">
            <input type="text" class="form-control" name="nombre" [(ngModel)]="fuenteUsu.nombresp">
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label>Cargo :</label>
          </div>
          <div class="col-10">
            <input type="text" class="form-control" name="cargo" [(ngModel)]="fuenteUsu.cargoresp">
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label>Teléfono :</label>
          </div>
          <div class="col-4">
            <input type="text" class="form-control" name="telefono" [(ngModel)]="fuenteUsu.telresp">
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label>Correo :</label>
          </div>
          <div class="col-10">
            <input type="text" class="form-control" name="correo" [(ngModel)]="fuenteUsu.email">
          </div>
        </div>
        <div class="d-grid gap-2 col-2 mx-auto">
          <button type="submit" class="btn btn-secondary" (click)="guardarFuente()">Guardar</button><!--[disabled]="btnguardar"-->
          <!--<button type="submit" class="btn btn-secondary" (click)="recuperarContrasena()">prueba</button>[disabled]="btnguardar"-->
        </div>
      </form>
    </div>
  </div>
</body>

<!--Normalizador de dirección-->
<div class="modal fade right"  id="modalPoll-NormDir" aria-hidden="true" data-backdrop="false">
  <div class="modal-dialog modal-full-height modal-right modal-notify modal-info modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header" id="modalheader">
        <h5 class="modal-title" id="ModalLabel">Ingresar Dirección</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row"><b>Por favor diligencia todos los campos que tiene *</b></div>
          <br>
          <div class="row">
            <div class="col-3"><label>Seleccione el tipo de vía: </label></div>
            <div class="col">
              <select class="form-select" name="tipovia" [(ngModel)]="DireccionPrueba.tipovia">
                <option value="">Sin vía</option>
                <option value="AU">(AU) Autopista</option>
                <option value="AV">(AV) Avenida</option>
                <option value="AC">(AC) Avenida Calle</option>
                <option value="AK">(AK) Avenida Carrera</option>
                <option value="BLV">(BLV) Boulevar</option>
                <option value="CL">(CL) Calle</option>
                <option value="CM">(CM) Camino</option>
                <option value="KR">(KR) Carrera</option>
                <option value="CV">(CV) Circunvalar</option>
                <option value="DG">(DG) Diagonal</option>
                <option value="PRJ">(PRJ) Paraje</option>
                <option value="PSJ">(PSJ) Pasaje</option>
                <option value="PAS">(PAS) Paseo</option>
                <option value="TV">(TV) Transversal</option>
                <option value="TC">(TC) Troncal</option>
                <option value="VT">(VT) Variante</option>
              </select>
            </div>
            <div class="col-1"><b>*</b></div>
          </div>
          <br>
            <div class="row">
              <div class="col-6"><label>Ingrese el número o nombre de la vía principal: </label></div>
              <div class="col"><input type="text" name="numnomvia" class="form-control" [(ngModel)]="DireccionPrueba.numvia" required></div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-6"><label>Seleccione la letra que acompaña la nomencaltura: </label></div>
              <div class="col">
                <select class="form-select" name="acomnomen" [(ngModel)]="DireccionPrueba.letravia">
                  <option value="">Sin letra</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                  <option value="E">E</option>
                  <option value="F">F</option>
                  <option value="G">G</option>
                  <option value="H">H</option>
                  <option value="I">I</option>
                  <option value="J">J</option>
                  <option value="K">K</option>
                  <option value="L">L</option>
                  <option value="M">M</option>
                  <option value="N">N</option>
                  <option value="O">O</option>
                  <option value="P">P</option>
                  <option value="Q">Q</option>
                  <option value="R">R</option>
                  <option value="S">S</option>
                  <option value="T">T</option>
                  <option value="U">U</option>
                  <option value="V">V</option>
                  <option value="W">W</option>
                  <option value="X">X</option>
                  <option value="Y">Y</option>
                  <option value="Z">Z</option>
                </select>
              </div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-4"><label>Seleccione el prefijo: </label></div>
              <div class="col">
                <select class="form-select" name="prefijo" [(ngModel)]="DireccionPrueba.prefijo">
                  <option value="">Sin prefijo</option>
                  <option value="Bis">Bis</option>
                </select>
              </div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-4"><label>Seleccione el cuadrante: </label></div>
              <div class="col">
                <select class="form-select" name="cuadranteuno" [(ngModel)]="DireccionPrueba.cuaduno">
                  <option value="">Sin cuadrante</option>
                  <option value="ESTE">ESTE</option>
                  <option value="NORTE">NORTE</option>
                  <option value="OESTE">OESTE</option>
                  <option value="SUR">SUR</option>
                  <option value="ESQUINA">ESQUINA</option>
                </select>
              </div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-6"><label>Ingrese el número que acompaña el prefijo: </label></div>
              <div class="col"><input type="text" name="numprefijouno" class="form-control" [(ngModel)]="DireccionPrueba.numpreuno"></div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-6"><label>Seleccione la letra que acompaña el prefijo: </label></div>
              <div class="col">
                <select class="form-select" name="letraprefijo" [(ngModel)]="DireccionPrueba.letpre">
                  <option value="">Sin letra</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                  <option value="E">E</option>
                  <option value="F">F</option>
                  <option value="G">G</option>
                  <option value="H">H</option>
                  <option value="I">I</option>
                  <option value="J">J</option>
                  <option value="K">K</option>
                  <option value="L">L</option>
                  <option value="M">M</option>
                  <option value="N">N</option>
                  <option value="O">O</option>
                  <option value="P">P</option>
                  <option value="Q">Q</option>
                  <option value="R">R</option>
                  <option value="S">S</option>
                  <option value="T">T</option>
                  <option value="U">U</option>
                  <option value="V">V</option>
                  <option value="W">W</option>
                  <option value="X">X</option>
                  <option value="Y">Y</option>
                  <option value="Z">Z</option>
                </select>
              </div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-6"><label>Ingrese el número que acompaña el prefijo: </label></div>
              <div class="col"><input type="text" name="numprefijodos" class="form-control" [(ngModel)]="DireccionPrueba.numpredos" maxlength="5"></div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-3"><label>Seleccione el cuadrante: </label></div>
              <div class="col">
                <select class="form-select" name="cuadrantedos" [(ngModel)]="DireccionPrueba.cuaddos">
                  <option value="">Sin cuadrante</option>
                  <option value="ESTE">ESTE</option>
                  <option value="NORTE">NORTE</option>
                  <option value="OESTE">OESTE</option>
                  <option value="SUR">SUR</option>
                  <option value="ESQUINA">ESQUINA</option>
                </select>
              </div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row"><b>Utilice complemento necesarios para completar la dirección</b></div>
            <br>
            <div class="row">
              <div class="col"><label>Seleccione el complemento de la dirección: </label></div>
              <div class="col">
                <select class="form-select" name="complementodirec" [(ngModel)]="DireccionPrueba.complemento" (change)="Complemento()">
                  <option value="">Sin complemento</option>
                  <option value="AD">(AD) Administración</option>
                  <option value="AGN">(AGN) Agencia</option>
                  <option value="AG">(AG) Agrupación</option>
                  <option value="ALM">(ALM) Almacen</option>
                  <option value="AL">(AL) Altillo</option>
                  <option value="APD">(APD) Apartado</option>
                  <option value="AST">(AST) Asentamiento</option>
                  <option value="BRR">(BRR) Barrio</option>
                  <option value="BL">(BL) Bloque</option>
                  <option value="BD">(BD) Bodega</option>
                  <option value="CS">(CS) Casa</option>
                  <option value="CAS">(CAS) Caserio</option>
                  <option value="CE">(CE) Célula</option>
                  <option value="CC">(CC) Centro Comercial</option>
                  <option value="CD">(CD) Ciudadela</option>
                  <option value="CDM">(CDM) Condominio</option>
                  <option value="CJ">(CJ) Conjunto</option>
                  <option value="CJR">(CJR) Conjunto Residencial</option>
                  <option value="CN">(CN) Consultorio</option>
                  <option value="CRG">(CRG) Corregimiento</option>
                  <option value="CTO">(CTO) Cuarto</option>
                  <option value="DO">(DO) Deposito</option>
                  <option value="DS">(DS) Depsito Sótano</option>
                  <option value="ED">(ED) Edificio</option>
                  <option value="EN">(EN) Entrada</option>
                  <option value="ESQ">(ESQ) Esquina</option>
                  <option value="ES">(ES) Estación</option>
                  <option value="ET">(ET) Etapa</option>
                  <option value="EX">(EX) Exterior</option>
                  <option value="FRR">(FRR) Ferrocarril</option>
                  <option value="FI">(FI) Finca</option>
                  <option value="GJ">(GJ) Garaje</option>
                  <option value="GS">(GS) Garaje Sótano</option>
                  <option value="HB">(HB) Habitación</option>
                  <option value="HC">(HC) Hacienda</option>
                  <option value="IN">(IN) Interior</option>
                  <option value="KM">(KM) Kilómetro</option>
                  <option value="LC">(LC) Local</option>
                  <option value="LM">(LM) Local Mezzanine</option>
                  <option value="LT">(LT) Lote</option>
                  <option value="MZ">(MZ) Manzana</option>
                  <option value="MN">(MN) Mezzanine</option>
                  <option value="MD">(MD) Módulo</option>
                  <option value="NV">(NV) Nivel</option>
                  <option value="OF">(OF) Oficina</option>
                  <option value="PA">(PA) Parcela</option>
                  <option value="PAR">(PAR) Parque</option>
                  <option value="PQ">(PQ) Parqueadero</option>
                  <option value="PTN">(PTN) Peatonal</option>
                  <option value="PH">(PH) Penthouse</option>
                  <option value="PS">(PS) Piso</option>
                  <option value="PN">(PN) Plan</option>
                  <option value="PL">(PL) Planta</option>
                  <option value="PZ">(PZ) Plaza</option>
                  <option value="PO">(PO) Portería</option>
                  <option value="PD">(PD) Predio</option>
                  <option value="PT">(PT) Puente</option>
                  <option value="PU">(PU) Puesto</option>
                  <option value="QT">(QT) Quinta</option>
                  <option value="RS">(RS) Residencia</option>
                  <option value="RP">(RP) Round Point</option>
                  <option value="SA">(SA) Salón</option>
                  <option value="SC">(SC) Salón Comunal</option>
                  <option value="SCT">(SCT) Sector</option>
                  <option value="SS">(SS) Semisótano</option>
                  <option value="SL">(SL) Solar</option>
                  <option value="SO">(SO) Sótano</option>
                  <option value="SU">(SU) Suite</option>
                  <option value="SM">(SM) Supermanzana</option>
                  <option value="TM">(TM) Terminal</option>
                  <option value="TZ">(TZ) Terraza</option>
                  <option value="TO">(TO) Torre</option>
                  <option value="UN">(UN) Unidad</option>
                  <option value="UR">(UR) Unidad Residencial</option>
                  <option value="UB">(UB) Urbanización</option>
                  <option value="VD">(VD) Vereda</option>
                  <option value="VIA">(VIA) Vía</option>
                  <option value="VDU">(VDU) Viaducto</option>
                  <option value="ZN">(ZN) Zona</option>
                  <option value="ZF">(ZF) Zona Franca</option>
                </select>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-9"><label>Ingrese el número o letra que acompña el complemento: </label></div>
              <div class="col"><input type="text" name="numletcomp" class="form-control" [(ngModel)]="DireccionPrueba.acomple"></div>
            </div>
            <br>
          <div>
            <div class="row" style="align-content: center; text-align: center;"><b>Dirección</b></div>
            <div><input type="text" name="direccionfinal" class="form-control" disabled
              placeholder="{{DireccionPrueba.tipovia}} {{DireccionPrueba.numvia}} {{DireccionPrueba.letravia}} {{DireccionPrueba.prefijo}} {{DireccionPrueba.cuaduno}} # {{DireccionPrueba.numpreuno}} {{DireccionPrueba.letpre}} {{DireccionPrueba.numpredos}} {{DireccionPrueba.cuaddos}} {{DireccionPrueba.acomple}}"></div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary" (click)="normalizarDireccion()">Aceptar</button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #closeModalDireccion>Cancelar</button>
      </div>
    </div>
  </div>
</div>

<!-- Ventana recuperar contraseña-->
<!-- Button trigger modal -->
<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalRecuperar" style="visibility: hidden;" #openModalRecuContraseña>Launch static backdrop modal</button>

<!-- Modal -->
<div class="modal fade" id="modalRecuperar" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalRecuperarLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 class="modal-title" id="modalRecuperarLabel" style="color: white;">Restablecer Contraseña</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!--form>
          <div class="row justify-content-center">
            <div class="col-auto"><label>Para restablecer su clave por favor ingrese nombre de usuario y la clave será enviada al correo registrado en el sistema.</label></div>
          </div>
          <div class="row justify-content-center">
            <div class="col-4"><label>Ingrese usuario :</label></div>
            <div class="col-6"><input type="text" class="form-control" id="contrasenaactual" name="contrasenaactual" [formControl]="RecuFormControl"></div>
          </div>
        </form   [disabled]="RecuFormControl.invalid" -->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #closeModalRecuContraseña style="visibility: hidden;">Close</button>
        <button type="button" class="btn btn-primary"  style="background-color: #be0c4d;" (click)="enviarCorreo()">Enviar</button>
      </div>
    </div>
  </div>
</div>
